import React from "react";
import "assets/css/safexpay-web.css";
import "./Reseller.css";
import ForPartners from "components/ForPartners/ForPartners.js";
// import Contactuspage from "components/Contactuspage/Contactuspage";

class HeroBanner extends React.Component {
  state = {
    open: false,
  };

  showcontactuspage = (props) => {
    console.log("button click.....");
    this.setState({
      open: !this.state.open,
    });
  };

  closepage = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    return (
      <>
        {/* <Contactuspage open={this.state.open} click={this.closepage}/> */}
        <section className="dv-HeroBanner dv-Reseller">
          <div className="first-bg"></div>
          <div className="second-bg"></div>
          <div className="third-bg"></div>
          <div className="container py-5">
            <div className="row">
              <div className="col-md-6 col-12 text-md-left text-center align-self-center pt-5">
                <h1 className="herobanner-heading">
                  <strong>
                    Earn more from your
                    <br />
                    existing clients
                  </strong>
                </h1>
                <p className="herobanner-content">
                  Let's do this together! We have everything you need to satisfy
                  your clients to accept or send money.
                </p>
                <div className="btn-wrapper">
                  <a href="/contact-us" className="btn btn-white-rounded">
                    TALK TO US
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-12 pt-5">
                <img
                  alt="safexpay-img"
                  className="img-fluid mt-5"
                  src={require("assets/img/banners/reseller.png")}
                />
              </div>
            </div>
          </div>

          <ForPartners />
        </section>
      </>
    );
  }
}

export default HeroBanner;
